<template>
    <SectionBasicLayout
        title='settings.whitelist.title.add_new'
        content_class="anti-spam"
        close_route="allowed-emails"
    >
        <template #actions>
            <ActionButton
                @click='onAddSender()'
                icon="fas fa-save"
                :loading=antispam_controller.content_state.saving
                v-tooltip='"global.actions.save_changes"'
                :gtm="{
                    module : `whitelist_settings`,
                    feature: `whitelist_form`,
                    block  : `top_actions`,
                    action : `submit`
                }"
            />
        </template>

        <template #content>
            <form>
                <fieldset class="bottom-space">
                    <legend>
                        {{Language.say('settings.whitelist.legends.add_sender_address')}}
                    </legend>
                    <InputRadio
                        input_id="ats-whitelist-rule"
                        input_name="radio"
                        :tag_text="`settings.whitelist.antispam_modal.options.`"
                        :options="{'address' : 'email', 'domain': 'domain'}"
                        v-model:input_value="rule"
                    />

                    <InputText
                        :input_focus=true
                        :input_id="`ale_sender_address_01`"
                        :input_name="'sender_address'"
                        :input_invalids="properties_validation.invalid"
                        :input_value="sender_address"
                        v-model:input_value="sender_address"
                        :label_text="'settings.whitelist.labels.add_sender_address'"
                        :error_text="properties_validation.custom_errors.sender_address || 'contacts.form.error_email'"
                        @keydown.enter.prevent='onAddSender()'
                    />

                </fieldset>

                <div class="submit-desktop">
                    <ActionButton
                        @click='onAddSender()'
                        class="main-action"
                        icon="fas fa-save"
                        text="global.actions.submit"
                        :loading=antispam_controller.content_state.saving
                        :gtm="{
                            module : `${list_type}_settings`,
                            feature: `${list_type}_form`,
                            block  : `bottom_actions`,
                            action : `submit`
                        }"
                    />
                </div>
            </form>
        </template>
    </SectionBasicLayout>
</template>

<script setup>
    import {reactive,  ref}     from 'vue';
    import {useRouter}          from 'vue-router';
    import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue';
    import SectionBasicLayout   from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
    import AntiSpamController   from '@/js/Settings/AntiSpam/AntiSpamController.js';
    import Language             from '@/js/Shared/Language/Language.js';
    import InputText            from '@/vue/Elements/Inputs/InputText.vue';
    import PropertiesValidation from '@/js/Shared/Validation/PropertiesValidation';
    import InputRadio           from '@/vue/Elements/Inputs/InputRadio.vue';

    const props = defineProps({
        antispam_controller: AntiSpamController,
    });

    const rule                   = ref('email');
    const sender_address         = ref('');
    const properties_validation  = reactive(new PropertiesValidation({
        'sender_address': {
            required       : true,
            regex          : rule.value
        },
    }));

    const router = useRouter();

    const onAddSender = async () => {
        properties_validation.rules.sender_address.regex = rule.value;
        properties_validation.reset();

        if (props.antispam_controller.data.whitelist.exists(sender_address.value)) {
            properties_validation.setInvalid('sender_address', 'settings.whitelist.errors.duplicate_sender');
            return;
        }

        properties_validation.setCustomError('sender_address', 'settings.whitelist.errors.' + rule.value);

        if (!properties_validation.validateField('sender_address', sender_address.value)) {
            return;
        }

        await props.antispam_controller.addWhitelistSenders([
            {
                rule   : rule.value,
                sender : sender_address.value,
            }
        ]);

        router.push(
            { name: 'allowed-emails-list' }
        );

    }
</script>
